import { useEffect, useState, useCallback } from 'react';

const KEY = 'fortnite_sprite_trades_v1';

const load = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    return JSON.parse(raw) || [];
  } catch (e) {
    return [];
  }
};

export function useTrades() {
  const [trades, setTrades] = useState(load);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(trades));
    } catch (e) {
      // ignore
    }
  }, [trades]);

  const addTrade = useCallback((data) => {
    const trade = {
      id: `T-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      createdAt: new Date().toISOString(),
      status: 'pending', // pending | accepted | completed | cancelled
      ...data,
    };
    setTrades((prev) => [trade, ...prev]);
    return trade;
  }, []);

  const updateTrade = useCallback((id, patch) => {
    setTrades((prev) => prev.map((t) => (t.id === id ? { ...t, ...patch } : t)));
  }, []);

  const removeTrade = useCallback((id) => {
    setTrades((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const clearAll = useCallback(() => setTrades([]), []);

  return { trades, addTrade, updateTrade, removeTrade, clearAll };
}
